const INICIAL = { ferramenta: null };

export default (state = INICIAL, action) => {
    if (action.type === 'FERRAMENTAS_SELECIONAR') {
        return { ...state, ferramenta: action.payload };
    }
    return state;
};
